import { Button } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useMenuCollapse } from "../../../../app/contexts/MenuCollapseContext";
import AntIcon from "../../../../common/components/icons/AntIcon";
import { Permission } from "../../../../common/security/enums";
import ComponentWithPermission from "../../../auth/components/ComponentWithPermission";
import styles from "./CalcNavigation.module.scss";

interface Props {
  onCalculate?: () => void;
  onGenerateContract?: () => void;
  onResetCalculatorClick?: () => void;
  onGoToPrevious?: () => void;
  requiredPermission?: Permission;
  goToCalcResults?: () => void;
}

export const CalcNavigation = ({
  onCalculate,
  onGenerateContract,
  onResetCalculatorClick,
  onGoToPrevious,
  requiredPermission,
  goToCalcResults,
}: Props) => {
  const { t } = useTranslation();

  const { isMenuCollapsed } = useMenuCollapse();

  return (
    <div className={classNames(styles.bottomFixedNavigation, { [styles.isCollapsed as string]: isMenuCollapsed })}>
      <div style={{ flex: 1 }}>
        {onResetCalculatorClick ? (
          <Button icon={<AntIcon type="reload" />} onClick={onResetCalculatorClick}>
            {t("common.resetCalculator")}
          </Button>
        ) : undefined}

        {onGoToPrevious ? (
          <Button
            icon={<AntIcon type="arrow-left" />}
            onClick={(event) => {
              event.currentTarget.blur();
              onGoToPrevious();
            }}
          >
            {t("common.back")}
          </Button>
        ) : undefined}
      </div>

      <div style={{ flex: 1, textAlign: "center" }}>
        {onCalculate ? (
          <Button
            icon={<AntIcon type="calculator" />}
            type="primary"
            size="large"
            onClick={(event) => {
              event.currentTarget.blur();
              onCalculate();
            }}
          >
            {t("common.calculate")}
          </Button>
        ) : undefined}

        {onGenerateContract ? (
          <ComponentWithPermission permissions={requiredPermission ? [requiredPermission] : []}>
            <Button
              icon={<AntIcon type="calculator" />}
              type="primary"
              size="large"
              onClick={(event) => {
                event.currentTarget.blur();
                onGenerateContract();
              }}
            >
              {t("calc.actions.generateContract")}
            </Button>
          </ComponentWithPermission>
        ) : undefined}
      </div>

      <div style={{ flex: 1, display: "flex", justifyContent: "end" }}>
        {goToCalcResults ? (
          <Button
            icon={<AntIcon type="arrow-right" />}
            iconPlacement="end"
            onClick={(event) => {
              event.currentTarget.blur();
              goToCalcResults();
            }}
          >
            {t("common.showResults")}
          </Button>
        ) : undefined}
      </div>
    </div>
  );
};
